// frontend/src/quiz_management/quizapp.js
// CLEANED VERSION - Student-only quiz interface (Teacher Dashboard removed)

import React, { useState, useEffect } from 'react';
import QuizList from './quizlist';
import QuizTaker from './quiztaker';
import StudentDashboard from './quizstudentdashboard';
import './quizapp.css';

const QuizApp = () => {
    const [currentView, setCurrentView] = useState('list'); // list, quiz, dashboard (removed teacher)
    const [selectedQuizId, setSelectedQuizId] = useState(null);
    const [studentId, setStudentId] = useState(null); // This should come from authentication
    const [student, setStudent] = useState(null);
    const [savedFilters, setSavedFilters] = useState({
        subject: '',
        chapter: '',
        topic: '',
        subtopic: '',  // Add this line
        filterType: 'all'  // Add this line
    });

    useEffect(() => {
        // Load student information from localStorage (from login)
        loadStudentInfo();
    }, []);

    useEffect(() => {
        // Push state when entering quiz
        if (currentView === 'quiz') {
            window.history.pushState({ view: 'quiz' }, '', '');
        }
        
        const handlePopState = (event) => {
            if (currentView === 'quiz') {
                // When back button pressed during quiz, go to list
                setCurrentView('list');
                setSelectedQuizId(null);
            }
        };
        
        window.addEventListener('popstate', handlePopState);
        
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [currentView]);

    const loadStudentInfo = async () => {
        try {
            // Get student from login data
            const studentData = localStorage.getItem('student');
            if (studentData) {
                const parsedStudent = JSON.parse(studentData);
                setStudent(parsedStudent);
                setStudentId(parsedStudent.student_id);
            } else {
                // Fallback to mock data if no login data
                setStudent({
                    student_id: studentId,
                    name: 'Student User',
                    email: 'student@example.com'
                });
            }
        } catch (err) {
            console.error('Error loading student info:', err);
            // Fallback to mock data
            setStudent({
                student_id: studentId,
                name: 'Student User',
                email: 'student@example.com'
            });
        }
    };

    const handleQuizSelect = (quizId) => {
        setSelectedQuizId(quizId);
        setCurrentView('quiz');
    };

    const handleQuizComplete = (results) => {
        // Show results for 3 seconds then go back to list
        setTimeout(() => {
            setCurrentView('list');
        }, 3000);
    };

    const handleBackToList = () => {
        setCurrentView('list');
        setSelectedQuizId(null);
    };

    const handleViewDashboard = () => {
        setCurrentView('dashboard');
    };

    return (
        <div className="quiz-app">
            {currentView !== 'quiz' && (
                <nav className="quiz-nav">
                    <div className="nav-brand">
                        <h2>Quiz Practice</h2>
                    </div>
                    
                    <div className="nav-student-info">
                        <span>Welcome, {student?.name || 'Student'}</span>
                    </div>
                    
                    <div className="nav-buttons">
                        <button 
                            className={`nav-btn ${currentView === 'list' ? 'active' : ''}`}
                            onClick={handleBackToList}
                        >
                            Quiz List
                        </button>
                        <button 
                            className={`nav-btn ${currentView === 'dashboard' ? 'active' : ''}`}
                            onClick={handleViewDashboard}
                        >
                        My Results
                        </button>
                        {/* REMOVED: Teacher Dashboard button */}
                    </div>
                </nav>
            )}

            <main className="quiz-main">
                {currentView === 'list' && (
                    <QuizList 
                        studentId={studentId}
                        onQuizSelect={handleQuizSelect}
                        onViewResults={handleViewDashboard}
                        savedFilters={savedFilters}
                        onFiltersChange={setSavedFilters}
                    />
                )}
                
                {currentView === 'quiz' && selectedQuizId && (
                    <div className="quiz-taking-view">
                        <div className="quiz-breadcrumb">
                            <button className="back-btn" onClick={handleBackToList}>
                                ← Back to Quiz List
                            </button>
                        </div>
                        <QuizTaker 
                            quizId={selectedQuizId}
                            studentId={studentId}
                            onQuizComplete={handleQuizComplete}
                        />
                    </div>
                )}
                
                {currentView === 'dashboard' && (
                    <StudentDashboard 
                        studentId={studentId}
                        onQuizSelect={handleQuizSelect}
                    />
                )}
                {/* REMOVED: Teacher Dashboard component */}
            </main>

            <footer className="quiz-footer">
                <p>&copy; 2025 Smart AI Tutor - Quiz Practice</p>
            </footer>
        </div>
    );
};

export default QuizApp;